import { render, staticRenderFns } from "./areaAppealList.vue?vue&type=template&id=6db8b966&scoped=true"
import script from "./areaAppealList.vue?vue&type=script&lang=js"
export * from "./areaAppealList.vue?vue&type=script&lang=js"
import style0 from "./areaAppealList.vue?vue&type=style&index=0&id=6db8b966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db8b966",
  null
  
)

export default component.exports